import { Link } from 'react-router-dom'
import { trackCtaClick } from '../utils/analytics'

interface CTABandProps {
  headline?: string
  description?: string
  primaryCta?: string
  primaryCtaLink?: string
  secondaryCta?: string
  secondaryCtaLink?: string
  variant?: 'light' | 'dark'
}

export default function CTABand({
  headline = "See Klarhead in action",
  description = "Book a personalized demo and discover how financial clarity transforms professional services management.",
  primaryCta = "Book a Demo",
  primaryCtaLink = "/contact",
  secondaryCta = "See Pricing",
  secondaryCtaLink = "/pricing",
  variant = 'light'
}: CTABandProps) {
  const isDark = variant === 'dark'

  return (
    <section className={`section-padding ${isDark ? 'bg-navy-900' : 'bg-navy-50'}`}>
      <div className="container-custom text-center">
        <h2 className={`text-3xl md:text-4xl font-bold ${isDark ? 'text-white' : 'text-navy-900'}`}>
          {headline}
        </h2>
        <p className={`mt-4 text-lg max-w-2xl mx-auto ${isDark ? 'text-navy-200' : 'text-navy-600'}`}>
          {description}
        </p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={primaryCtaLink} className="btn-primary" onClick={() => trackCtaClick('band_demo')}>
            {primaryCta}
          </Link>
          {secondaryCta && (
            <Link
              to={secondaryCtaLink}
              className={isDark ? 'btn-outline text-white border-white hover:bg-navy-800' : 'btn-secondary'}
              onClick={() => trackCtaClick('band_secondary')}
            >
              {secondaryCta}
            </Link>
          )}
        </div>
      </div>
    </section>
  )
}
